var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpacePlanet9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_336_31170)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_31170)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.677734,
    y: 64.8848,
    width: 70.1893,
    height: 70.1893,
    rx: 35.0947,
    transform: "rotate(-67.3553 0.677734 64.8848)",
    fill: "#B2E4F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_336_31170)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8735,
    cy: 46.4424,
    rx: 38.0777,
    ry: 37.3311,
    transform: "rotate(-67.3553 39.8735 46.4424)",
    fill: "#86EFC9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_f_336_31170)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2457,
    cy: 47.6339,
    rx: 23.5391,
    ry: 22.9787,
    transform: "rotate(-67.3553 28.2457 47.6339)",
    fill: "#DDF3FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_336_31170)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.97071,
    cy: 5.96606,
    rx: 9.97071,
    ry: 5.96606,
    transform: "matrix(0.203731 -0.979027 0.980524 0.196399 64.541 59.2048)",
    fill: "#CEF4CB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_336_31170",
    x: 0.677734,
    y: 0.106201,
    width: 91.8027,
    height: 91.8025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_336_31170"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.576042 0 0 0 0 0.740625 0 0 0 0 0.9875 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_336_31170"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_336_31170",
    x: -57.5791,
    y: -51.5356,
    width: 194.905,
    height: 195.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_336_31170"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_336_31170",
    x: -44.8232,
    y: -25.8291,
    width: 146.138,
    height: 146.926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_336_31170"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_336_31170",
    x: 36.2275,
    y: 10.7822,
    width: 72.3887,
    height: 79.6653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_336_31170"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_31170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.677734,
    y: 64.8848,
    width: 70.1893,
    height: 70.1893,
    rx: 35.0947,
    transform: "rotate(-67.3553 0.677734 64.8848)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacePlanet9);
export default __webpack_public_path__ + "static/media/spacePlanet9.4bdff2f6b0ca2ef24471e31078d09a35.svg";
export { ForwardRef as ReactComponent };